import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory, EntityDataService } from '@ngrx/data';
import { WORKSPACE_ENTITY_NAME } from '../constants';
import { WorkspaceState } from '../models';
import { WorkspaceDataService } from '../services';

@Injectable({ providedIn: 'root' })
export class WorkspaceStore extends EntityCollectionServiceBase<WorkspaceState> {
  constructor(
    entityDataService: EntityDataService,
    dataService: WorkspaceDataService,
    serviceElementsFactory: EntityCollectionServiceElementsFactory,
  ) {
    entityDataService.registerService(WORKSPACE_ENTITY_NAME, dataService);
    super(WORKSPACE_ENTITY_NAME, serviceElementsFactory);
  }
}
